<script setup lang="ts">
import { computed } from 'vue'
import { useImageSrc } from '@/composables/useImageSrc'

const props = defineProps<{
  itemId?: string
  /** A direct URL, used for a local preview before the upload settles; wins over `itemId`. */
  src?: string
  alt?: string
}>()

const resolved = useImageSrc(computed(() => (props.src ? null : (props.itemId ?? null))))

const displaySrc = computed(() => props.src ?? resolved.value)
</script>

<template>
  <img :src="displaySrc" :alt="alt ?? ''" />
</template>
